export default __webpack_public_path__ + "static/features_back-daa67ca8665bde8d6c5d061530ff9aa5.webp";